'use strict';

window.TES = window.TES || {};

$(function () {

    var resourceAuthor = window.TES.resource && window.TES.resource.authorId.toString();

    var user = window.TES.user;

    function currentUserIsAuthor() {
        return user.isAuthenticated() && user.getId() === resourceAuthor;
    }

    function currentUserIsResourceAdmin() {
        return user.isAuthenticated() && user.hasRole('ResourceAdminUser');
    }

    function enableAuthorControls() {
        if (currentUserIsAuthor() || currentUserIsResourceAdmin()) {
            $('.author-controls').show();
        }
    }

    function enableProblemReporting() {
        var $reportProblem = $('#ContentPlaceHolder2_lnkReportProblem');
        var href = $reportProblem.attr('href');
        href = href + encodeURI('Resource Title: ' + $('.tes-resource-summary-title').text() +
            '\nLink to resource: ' + window.location +
            '\n\nProblem:');
        $reportProblem.attr('href', href);
    }

    enableProblemReporting();
    enableAuthorControls();
});
